// extracted by mini-css-extract-plugin
export var overlay = "project-thumbnail-module--overlay--+Dgot";
export var overlayVisible = "project-thumbnail-module--overlay-visible--nSPa7";
export var projectThumbnail = "project-thumbnail-module--project-thumbnail--MT8XL";
export var projectThumbnailWrapper = "project-thumbnail-module--project-thumbnail-wrapper--wHgv-";
export var thumbnail = "project-thumbnail-module--thumbnail--uV+9-";